import { useState } from 'react';
export const useStepNavigation = (initialStepKey) => {
    const [stepHistory, setStepHistory] = useState([]);
    const [activeStepKey, setActiveStepKey] = useState(initialStepKey);
    const canGoBack = () => stepHistory.length > 0;
    const goBackOneStep = () => {
        if (stepHistory.length === 0)
            return;
        const lastAddedItemInHistory = stepHistory[stepHistory.length - 1];
        const updatedHistory = stepHistory.slice(0, -1);
        setStepHistory(updatedHistory);
        if (lastAddedItemInHistory !== undefined)
            setActiveStepKey(lastAddedItemInHistory.key);
    };
    const addStepToHistory = (stepKey) => {
        const stepHistoryCopy = [...stepHistory];
        if (stepHistory.some((existingStep) => existingStep.key === stepKey))
            return;
        stepHistoryCopy.push({ key: stepKey });
        setStepHistory(stepHistoryCopy);
    };
    const goToStep = (newStepKey) => {
        addStepToHistory(activeStepKey);
        setActiveStepKey(newStepKey);
    };
    return {
        goBackOneStep,
        goToStep,
        canGoBack,
        activeStepKey,
    };
};
//# sourceMappingURL=useStepNavigation.js.map